import { useTranslation } from 'react-i18next'
import { CompanyType } from '../../models'
import { useUserStore } from '../userStore'

export const useOfferionTranslation = () => {
    const companyType = useUserStore(state => state.user.CompanyType)

    const { t } = useTranslation()

    return {
        t: (key: string, options?: {}) => {
            return t(key, { ...options, context: companyType === CompanyType.Lawyer ? 'lawyer' : '' })
        },
    }
}

export default useOfferionTranslation
